import type { SendingAnomalyDetail } from '@repo/sdk/gen'
import { makeBreadcrumbFromCache } from '@repo/ui/components/query-breadcrumbs'
import { createFileRoute, notFound } from '@tanstack/react-router'
import i18n from '@/lib/i18n'
import { makeQueryKeys } from '@/query/query-keys'
import { sendingAnomalyQueryOptions } from '../-query/query-options'
import { AnomalyDetailPage } from './-components/anomaly-detail-page'

export const Route = createFileRoute('/(private)/invii/$anomalyId/')({
	loader: async ({ context, params }) => {
		try {
			await context.queryClient.ensureQueryData({
				...sendingAnomalyQueryOptions(params.anomalyId),
				revalidateIfStale: true
			})
		} catch (error) {
			if (
				typeof error === 'object' &&
				error !== null &&
				'code' in error &&
				error.code === 'sending_anomaly_not_found'
			) {
				throw notFound()
			}
			throw error
		}
	},
	staticData: {
		breadcrumb: ({ params, queryClient }) =>
			makeBreadcrumbFromCache<SendingAnomalyDetail>(
				queryClient,
				makeQueryKeys.sendingAnomalies.detail(params.anomalyId ?? ''),
				(detail) => i18n.t(`admin-sending:kind.${detail.anomaly.kind}`)
			)
	},
	component: AnomalyDetail
})

function AnomalyDetail() {
	const { anomalyId } = Route.useParams()
	return <AnomalyDetailPage anomalyId={anomalyId} />
}
